import { ExclamationCircleFilled } from '@ant-design/icons';
import { Account, AccountStatus, AccountType } from 'src/models';
import { Color } from 'src/styles';
import { Maybe } from 'src/utils';

export enum HeaderMenuItemKey {
  MyAccount = 'MyAccount',
  MoneyTransfers = 'MoneyTransfers',
  AccountStatus = 'AccountStatus',
  AccountStatements = 'AccountStatements',
  ChangeEmail = 'ChangeEmail',
  IndicationsOfInterest = 'IndicationsOfInterst',
}

export interface HeaderMenuItem {
  key: HeaderMenuItemKey;
  name: string;
  path: (id?: string) => string;
  isVisible: (param: {
    type?: AccountType;
    isEntityAccountTypeActive?: boolean;
    lastFailedLinkAccountError?: string;
  }) => boolean;
  startIcon?: () => Maybe<JSX.Element>;
  endIcon?: (status?: AccountStatus) => Maybe<JSX.Element>;
}

export const accountSettingMenuItemList: HeaderMenuItem[] = [
  {
    key: HeaderMenuItemKey.MoneyTransfers,
    name: 'Money Transfers & Preferences',
    path: (id?: string) => `/accounts/${id}/money-transfers`,
    isVisible: ({ type, isEntityAccountTypeActive = false, lastFailedLinkAccountError }) =>
      type?.isEntity ? isEntityAccountTypeActive : !Boolean(lastFailedLinkAccountError),
  },
  {
    key: HeaderMenuItemKey.AccountStatus,
    name: 'Account Status',
    path: (id?: string) => `/accounts/${id}/account-status`,
    isVisible: () => true,
    endIcon: (status?: AccountStatus) =>
      status ? (
        status.isPending || status.isPendingEntityActivation || status.isPendingLinkError ? (
          <ExclamationCircleFilled style={{ fontSize: '24px', color: Color.Orange6 }} />
        ) : status.isRejected ? (
          <ExclamationCircleFilled style={{ fontSize: '24px', color: Color.Red6 }} />
        ) : undefined
      ) : undefined,
  },
  {
    key: HeaderMenuItemKey.AccountStatements,
    name: 'Statements & Documents',
    path: (id?: string) => `/accounts/${id}/statements`,
    isVisible: ({ type, isEntityAccountTypeActive = false, lastFailedLinkAccountError }) =>
      type?.isEntity ? isEntityAccountTypeActive : !Boolean(lastFailedLinkAccountError),
  },
];

export const getAccountSettingMenuItemList = (account?: Account): HeaderMenuItem[] => {
  if (!account?.accountId) {
    return [];
  }

  return accountSettingMenuItemList.filter(item =>
    item.isVisible({
      type: account.type,
      isEntityAccountTypeActive: account.isEntityAccountTypeActive,
      lastFailedLinkAccountError: account.lastFailedLinkAttemptError,
    }),
  );
};

export const userSettingMenuItemList: HeaderMenuItem[] = [
  {
    key: HeaderMenuItemKey.IndicationsOfInterest,
    name: 'Indications of Interest',
    path: () => `/user/indications-of-interest`,
    isVisible: () => true,
  },
  {
    key: HeaderMenuItemKey.ChangeEmail,
    name: 'Change Email Address & Phone Number',
    path: () => '/user/settings',
    isVisible: ({ type, isEntityAccountTypeActive = false }) => (type?.isEntity ? isEntityAccountTypeActive : true),
  },
];

export const getUserSettingMenuItemList = (account?: Account): HeaderMenuItem[] => {
  if (!account?.accountId) {
    return [
      {
        key: HeaderMenuItemKey.IndicationsOfInterest,
        name: 'Indications of Interest',
        path: () => `/user/indications-of-interest`,
        isVisible: () => true,
      },
    ];
  }

  return userSettingMenuItemList.filter(item =>
    item.isVisible({ type: account.type, isEntityAccountTypeActive: account.isEntityAccountTypeActive }),
  );
};
